import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, EmptyState, pxToRem } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Link } from 'react-router-dom';
export function DocumentNotFoundError() {
    return (<Box height="100%" width="100%" alignItems="center" justifyContent="center">
      <EmptyState style={{ maxWidth: pxToRem(540) }} withAvatar icon={<Falcon icon="file"/>} title={t({
            message: "You can't access this document",
            comment: 'Document not found error title',
        })} description={t({
            message: "The document you tried to open is either unavailable or you don't have permission to view it. If you need access, contact the contract owner or your system administrator.",
            comment: 'Document not found error description',
        })} actions={<Button as={Link} size="small" to="/">
            <Trans comment="Document not found error - Take me back button label">Take me back</Trans>
          </Button>}/>
    </Box>);
}
